<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Πρότυπο:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit Service id:  {{ $route.params.id }}
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput type="text" addLabelClasses="requiredLabel" label="Τίτλος" id="company" placeholder="Τίτλος" v-model="name" horizontal></CInput>
            <CInput type="text" label="Standard name (IAF)" id="iaf_title" placeholder="Standard name (IAF)" v-model="iaf_title" horizontal></CInput>
            <CInput type="text" label="Scheme Name" id="scheme_name" placeholder="Scheme Name" v-model="scheme_name" horizontal></CInput>
            <CInput type="text" label="Πρόθεμα IAF" id="iaf_prefix" placeholder="Πρόθεμα IAF" v-model="iaf_prefix" horizontal></CInput>
            <div class="form-group form-row">
              <CCol tag="label" sm="3" class="col-form-label">Ομάδα</CCol>
              <CCol sm="9">
                <div class="d-flex">
                  <select class="form-control mr-2" v-model="group_id">
                    <option value="">-- Επιλέξτε ομάδα --</option>
                    <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
                  </select>
                  <CButton color="success" size="sm" @click="showNewGroupModal = true" title="Νέα ομάδα">+</CButton>
                </div>
              </CCol>
            </div>
            <CTextarea id="description" addLabelClasses="requiredLabel" label="Περιγραφή" placeholder="Περιγραφή" v-model="description" horizontal></CTextarea>

            <!-- New Group Modal -->
            <CModal :show.sync="showNewGroupModal" :centered="true" title="Νέα Ομάδα">
              <CInput label="Όνομα Ομάδας" v-model="newGroupName" placeholder="π.χ. ISO 17021-1" />
              <template #footer>
                <CButton color="secondary" @click="showNewGroupModal = false">Ακύρωση</CButton>
                <CButton color="primary" @click="createGroup">Δημιουργία</CButton>
              </template>
            </CModal>
            <CButton color="primary" @click="update()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
export default {
  name: 'EditService',
  props: {
    caption: {
      type: String,
      default: 'Service id'
    },
  },
  data: () => {
    return {
        title: '',
        name: '',
        iaf_title: '',
        scheme_name: '',
        iaf_prefix: '',
        group_id: '',
        groups: [],
        description: '',
        showMessage: false,
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        showNewGroupModal: false,
        newGroupName: ''
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/services'})
    },
    update() {
        let self = this;
        axios.post('/api/services/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            name: self.name,
            iaf_title: self.iaf_title,
            scheme_name: self.scheme_name,
            iaf_prefix: self.iaf_prefix,
            group_id: self.group_id || null,
            description: self.description,
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία υπηρεσίας.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    loadGroups() {
      let self = this;
      axios.get('/api/service-groups?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          self.groups = response.data.groups || [];
        }).catch(function (error) {
          console.log(error);
        });
    },
    createGroup() {
      let self = this;
      if (!self.newGroupName.trim()) return;
      axios.post('/api/service-groups?token=' + localStorage.getItem("api_token"), {
        name: self.newGroupName
      })
        .then(function (response) {
          self.groups.push(response.data);
          self.group_id = response.data.id;
          self.newGroupName = '';
          self.showNewGroupModal = false;
        }).catch(function (error) {
          console.log(error);
          if (error.response && error.response.data.errors) {
            alert(error.response.data.errors.name[0]);
          }
        });
    }
  },
  mounted: function(){
    let self = this;
    self.loadGroups();
    axios.get('/api/services/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        const ser_items = Object.entries(response.data).map(([key, value]) => {return {key: key, value: value}});
        const keys = ["name", "description"];
        self.items = ser_items.filter((t) => keys.includes(t.key));
        self.title = self.items.find((t) => t.key == "name").value;

        self.name = response.data.name;
        self.iaf_title = response.data.iaf_title || '';
        self.scheme_name = response.data.scheme_name || '';
        self.iaf_prefix = response.data.iaf_prefix || '';
        self.group_id = response.data.group_id || '';
        self.description = response.data.description;
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}


</script>
